import { ImportedSportEquipmentRecord } from "./types";
import { TechnicalCondition } from "graphql/graphQlApiHooks";

export function rowValidate(data: ImportedSportEquipmentRecord) {
  let validateErrors: any = {
    id: data?.id
  };

  if (!data.name || data.name === "") {
    validateErrors = {
      ...validateErrors, name: {
        error: true,
        message: "Введите название оборудования."
      }
    };
  }

  if (!data.inventoryNumber || data.inventoryNumber === "") {
    validateErrors = {
      ...validateErrors, inventoryNumber: {
        error: true,
        message: "Укажите инв. номер."
      }
    };
  }
  if (!data?.sportObject) {
    validateErrors = {
      ...validateErrors, sportObject: {
        error: true,
        message: "Выберите спортивный объект."
      }
    };
  }
  // sportZone и sportSubZone необязательны согласно API
  if (!data?.commissioningDate) {
    validateErrors = {
      ...validateErrors, commissioningDate: {
        error: true,
        message: "Добавьте дату ввода в эксплуатацию"
      }
    };
  }
  if (data?.commissioningDate && !data?.isCommissioningDateCorrect) {
    validateErrors = {
      ...validateErrors, commissioningDate: {
        error: true,
        message: "Дата ввода в эксплуатацию некорректна"
      }
    };
  }
  if (!data?.sportCategory) {
    validateErrors = {
      ...validateErrors, sportCategory: {
        error: true,
        message: "Выберите категорию оборудования"
      }
    };
  }
  if (!data?.sportKind) {
    validateErrors = {
      ...validateErrors, sportKind: {
        error: true,
        message: "Выберите вид спорта"
      }
    };
  }
  if (!data?.equipmentType) {
    validateErrors = {
      ...validateErrors, equipmentType: {
        error: true,
        message: "Выберите тип оборудования"
      }
    };
  }

  if (data?.technicalCondition === TechnicalCondition.NotWorking) {
    if (!data?.failureReason || data.failureReason.trim() === "") {
      validateErrors = {
        ...validateErrors,
        failureReason: {
          error: true,
          message: "Укажите причину неисправности"
        }
      };
    }
  }


  return validateErrors;

}
